
// globals
import Events from '@st-operations/uikit/Events.js'
import Storage from '@st-operations/uikit/Storage.js'

// class
const Team = {};

Team.data = null;

Team.set = function set(data) {
  Team.data = data;
  Storage.set('team', data);
  Events.emit('team', data);
};

Team.watch = (component, callback) => {
  const team = Team.data;
  component.setState({ team }, () => {
    if (callback) {
      callback(team);
    }
  });

  Events.addListener('team', (team) => {
    component.setState({ team }, () => {
      if (callback) {
        callback(team);
      }
    });
  });
};

Team.unset = function unset() {
  Team.set(null);
};

// export
export default Team;
